import styled from 'styled-components';

const offsetAmount = '55px';

export const TeamScoresWrapper = styled.div`
  display: inline-block;
  font-size: 18px;
  color: var(--gameday-primary-font-color);
  font-weight: ${({ scored }) => scored ? '700' : '500'};
  margin-right: 4px;
  height: 100%;
  b {
    &:not(:first-child) {
      margin-left: 3px;
    }
    &:not(:last-child) {
      margin-right: 3px;
    }
  }
`;

export const TeamLogoWrapper = styled.div`
  background-color: transparent;
  left: ${({ $offset }) => $offset ? `-${offsetAmount}` : '0px'};
  top: 0px;
  height: 48px;
  width: 48px;
  position: absolute;
  border-radius: 50%;
  border: 2px solid var(--gameday-background-color);
  box-sizing: content-box;
`;

export const PlayScoresWrapper = styled.div`
  font-family: var(--gameday-primary-font); 
  position: relative;
  height: 52px;
  line-height: 52px;
  padding-left: ${({ $offset }) => !$offset ? offsetAmount : '8px'};
  display: flex;
  align-items: center;
  width: 100%;

  ${TeamScoresWrapper} {
    &:last-child {
      padding-left: 3px;
    }
  }
`;
